import { actionInterceptor } from '../middleware/actionsInterceptorMiddleware';
import {
  BaseUserProfileStoreModel,
  OidcModel,
  handleFulfilledAction,
  handleLoadingAction,
  userProfileStoreName,
} from '@hwm/ui-lib';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { userProfileThunks } from './user-profile.thunks';
import { rainfallEntity } from '../rainfall';
import { alarmSubscriptionsReducer } from '../alarmSubscriptions/AlarmSubscriptionsReducer';

export interface UserProfileStoreState extends BaseUserProfileStoreModel {}

const initialState: UserProfileStoreState = {
  username: '',
  userId: null,
  type: null,
  language: 'en-GB',
  permissions: undefined,
  featureFlags: undefined,
  oidc: {
    idToken: '',
    isLoadingUser: true,
    user: null as any,
    accessToken: '',
  },
  error: null,
  loadingPending: 0,
};

const slice = createSlice({
  name: userProfileStoreName,
  initialState,
  reducers: {
    setName: (state, action: PayloadAction<string>) => {
      state.username = action.payload;
    },
    setOidcUser: (state, action: PayloadAction<Partial<OidcModel>>) => {
      state.oidc = { ...state.oidc, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    handleLoadingAction(userProfileThunks.getUserProfile, builder);
    handleLoadingAction(userProfileThunks.getUserPermissions, builder);
    handleLoadingAction(userProfileThunks.getTopLvlFeatureFlags, builder);
    handleFulfilledAction(userProfileThunks.getUserProfile, builder, (state, payload) => {
      state.username = payload.name;
      state.userId = payload?.userId;
      state.type = payload?.type?.toString();
      state.language = payload?.languageCode ?? 'en-GB';
    });
    handleFulfilledAction(userProfileThunks.getUserPermissions, builder, (state, payload) => {
      state.permissions = payload;
    });
    handleFulfilledAction(userProfileThunks.getTopLvlFeatureFlags, builder, (state, payload) => {
      state.featureFlags = payload;
    });
  },
});

export const userProfileReducer = {
  slice,
};

actionInterceptor.addActionsCallback<any>({
  actionTypes: [userProfileReducer.slice.actions.setOidcUser.type],
  callback: ({ dispatch, state }) => {
    if (state[userProfileStoreName].loadingPending <= 0) {
      if (!state[userProfileStoreName].username) {
        dispatch(userProfileThunks.getUserProfile());
      }
      if (!state[userProfileStoreName].permissions) {
        dispatch(userProfileThunks.getUserPermissions());
      }
      if (!state[userProfileStoreName].featureFlags) {
        dispatch(userProfileThunks.getTopLvlFeatureFlags());
      }
    }
  },
});

actionInterceptor.addActionsCallback<typeof userProfileThunks.getUserProfile.fulfilled>({
  actionTypes: [userProfileThunks.getUserProfile.fulfilled.type],
  callback: ({ dispatch }) => {
    dispatch(rainfallEntity.thunks.getRainfallEnabled());
    dispatch(alarmSubscriptionsReducer.thunks.getByClaims());
  },
});
